var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup10825(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10825",
    "data-name": "Group 10825",
    transform: "translate(-1770 -65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4736",
    "data-name": "Path 4736",
    d: "M1298.75,360.75c0-18.749,6.243-25,25-25s25,6.251,25,25-6.243,25-25,25S1298.75,379.5,1298.75,360.75Z",
    transform: "translate(471.25 -270.75)",
    fill: "#e7e8ea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3670",
    "data-name": "Path 3670",
    d: "M785.392,340.33a5.313,5.313,0,1,1-1.556-3.775A5.313,5.313,0,0,1,785.392,340.33Zm-5.333,14.817c-4.37,0-8.059-.705-8.059-3.45s3.712-3.425,8.059-3.425c4.371,0,8.059.705,8.059,3.45S784.406,355.147,780.059,355.147Z",
    transform: "translate(1015 -255)",
    fill: "#a3a5ad",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup10825);
export default __webpack_public_path__ + "static/media/Group 10825.34ac072307d3168c9a4db080ff2b5b9a.svg";
export { ForwardRef as ReactComponent };